// extracted by mini-css-extract-plugin
export default {"header":"StockHeader_header__ludiF","header--fullBottomBorderRadius":"StockHeader_header--fullBottomBorderRadius__dQsFi","header--short":"StockHeader_header--short__+Kz-r"};